import { I18n } from '@traveloka/district-i18n';

const i18n = new I18n();
const DEFAULT_LANGUAGE = 'id';
const languageScopes = {
  id: require('./localization/id.json'),
};

Object.entries(languageScopes).forEach(([locale, scope]) => {
  i18n.addLanguageScope(locale, scope);
});
i18n.setActiveLocale(DEFAULT_LANGUAGE);

export default {
  getLocale: () => i18n.getActiveLocale(),
  setLocale: locale => i18n.setActiveLocale(locale),
  getText: (scope, variables = {}) => i18n.t(scope, { variables }),
};
